import React, { ReactNode } from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

interface ToolTipProps {
  message: string | ReactNode;
  children: ReactNode;
  position?: "top" | "right" | "bottom" | "left";
  hideTooltip?: boolean;
}
const Tooltip: React.FC<ToolTipProps> = ({
  message,
  children,
  position = "bottom",
  hideTooltip = false,
}) => {
  if (message) {
    return (
      <Tippy
        content={<span className="font-medium text-base">{message}</span>}
        disabled={hideTooltip}
        placement={position}
      >
        <div id={message as string}>{children}</div>
      </Tippy>
    );
  } else {
    return children;
  }
};

export default Tooltip;
